import { Divider, IconButton, Menu } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowDownToBracket, faBars, faCopy, faEye, faFile, faPrint, faTrash } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useAnchorMenu } from "../../../../../../shared/hooks/useAnchorMenu"

import { OverflowMenuEntry, OverflowMenuItem } from "./OverflowMenuItem"

const useStyles = makeStyles()((theme) => ({
    button: {
        width: "3rem",
        height: "3rem",
        border: `1px solid ${theme.palette.tailwind.slate[300]}`,
        borderRadius: ".75rem",
        background: theme.palette.background.paper,
        color: theme.palette.tailwind.slate[800],
        "& svg": {
            fontSize: "1.125rem",
        },
        "&:hover": {
            borderColor: theme.palette.tailwind.slate[400],
            background: theme.palette.tailwind.slate[50],
        },
    },
    paper: {
        marginTop: ".5rem",
    },
}))

type Props = Readonly<{
    onCopyWeek: () => void
    onClearWeek: () => void
    onManageTemplates: () => void
    onCustomerPreview: () => void
    onExportPdf: () => void
    onPrintKitchenSheet: () => void
}>

export function WeekMenuOverflowMenu({
    onCopyWeek,
    onClearWeek,
    onManageTemplates,
    onCustomerPreview,
    onExportPdf,
    onPrintKitchenSheet,
}: Props) {
    const { classes } = useStyles()
    const { anchorEl, isOpen, open, close, closeThen } = useAnchorMenu()

    const entryGroups: ReadonlyArray<ReadonlyArray<OverflowMenuEntry>> = [
        [
            {
                labelId: "merchant-week-menu-overflow-copy-week-item",
                label: "Copy Week",
                icon: faCopy,
                onClick: onCopyWeek,
            },
            {
                labelId: "merchant-week-menu-overflow-clear-week-item",
                label: "Clear Week",
                icon: faTrash,
                onClick: onClearWeek,
            },
        ],
        [
            {
                labelId: "merchant-week-menu-overflow-manage-templates-item",
                label: "Manage Templates",
                icon: faFile,
                onClick: onManageTemplates,
            },
            {
                labelId: "merchant-week-menu-overflow-customer-preview-item",
                label: "Customer Preview",
                icon: faEye,
                onClick: onCustomerPreview,
            },
            {
                labelId: "merchant-week-menu-overflow-export-pdf-item",
                label: "Export to PDF",
                icon: faArrowDownToBracket,
                onClick: onExportPdf,
            },
            {
                labelId: "merchant-week-menu-overflow-print-item",
                label: "Print kitchen sheet",
                icon: faPrint,
                onClick: onPrintKitchenSheet,
            },
        ],
    ]

    return (
        <>
            <LocalizedStrict id="merchant-week-menu-overflow-button" attrs={{ "aria-label": true }}>
                <IconButton aria-label="More actions" className={classes.button} onClick={open}>
                    <FontAwesomeIcon icon={faBars} />
                </IconButton>
            </LocalizedStrict>
            <Menu
                open={isOpen}
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                slotProps={{ paper: { className: classes.paper } }}
                onClose={close}
            >
                {entryGroups.flatMap((group, groupIndex) => [
                    ...(groupIndex > 0 ? [<Divider key={`group-divider-${groupIndex}`} />] : []),
                    ...group.map((entry) => (
                        <OverflowMenuItem key={entry.labelId} entry={entry} onClick={closeThen(entry.onClick)} />
                    )),
                ])}
            </Menu>
        </>
    )
}
